import React from "react";
import { Route } from "react-router-dom";

export default ({ component: Component, ourTeam, ...rest }) => {
  // window.onhashchange = null;
  return (
    <Route
      {...rest}
      render={(props) => <Component ourTeam={ourTeam} {...props} />}
    />
  );
};
